import React from 'react';
import { Stack, Typography } from '@mui/material';
import EditNoteIcon from '@mui/icons-material/EditNote';

import { NoteDisplay } from '../../components';
import type { TimelineItem } from '../HistoryDialog.types.ts';
import { TimelineItemSection } from '../TimelineItemSection.tsx';

type NoteUpdateDisplayProps = {
  stepId: string;
  noteConfig: TimelineItem<'UPDATE_NOTE'>['metadata']['newNote'];
};

const NoteUpdateDisplay: React.FC<NoteUpdateDisplayProps> = ({ stepId, noteConfig }) => {
  if (!noteConfig) {
    return <Typography variant="caption">No note</Typography>;
  }

  return <NoteDisplay stepId={stepId} noteConfig={noteConfig} />;
};

type NoteUpdateActionProps = {
  item: TimelineItem<'UPDATE_NOTE'>;
};

export const NoteUpdateAction: React.FC<NoteUpdateActionProps> = ({ item }) => {
  if (item.action !== 'UPDATE_NOTE') {
    return null;
  }

  if (!item.metadata) {
    return null;
  }

  const { previousNote, newNote } = item.metadata;

  return (
    <TimelineItemSection title="Note Updated" Icon={EditNoteIcon}>
      <Stack direction={{ xs: 'column', sm: 'row' }} alignItems="flex-start" gap={1} justifyContent="space-between">
        <Stack flex={1}>
          <Typography variant="caption" fontWeight="bold">
            Previous note
          </Typography>
          <NoteUpdateDisplay stepId={item.stepId} noteConfig={previousNote} />
        </Stack>
        <Stack flex={1}>
          <Typography variant="caption" fontWeight="bold">
            New note
          </Typography>
          <NoteUpdateDisplay stepId={item.stepId} noteConfig={newNote} />
        </Stack>
      </Stack>
    </TimelineItemSection>
  );
};
